import React, { Component } from 'react';
import { Card, Button, CardDeck } from 'react-bootstrap';
import { ArrowUpward } from '@material-ui/icons';

import _ from 'lodash';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis
} from 'recharts';
import { Fab } from '@material-ui/core';
import UserForm from './UserForm';
import ProfessionalXPForm from './ProfessionalXPForm';
import LanguageForm from './LanguageForm';

const monthsName = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

class UserDashboard extends Component {
  constructor() {
    super();

    this.state = {
      pulses: [],
      userProfileData: ''
    };
  }

  async componentDidMount() {
    const _pulses = await this.props.getPulsesForUser();
    this.setState({
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: monthsName[monthIndex]
        })),
        []
      ),
      userProfileData: this.props.currentUser
    });
  }

  render() {
    const scrollTo = ref => {
      if (ref) {
        ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const { pulses = [], userProfileData = {} } = this.state;
    const { courses = [] } = this.props;
    const {
      turnOnLoading,
      turnOffLoading,
      setCurrentUser,
      currentUser,
      areasList
    } = this.props;

    const { roleName } = this.props.currentUser;
    const currentAvatar = this.props.currentInstitution.avatar[roleName];

    let data = [];
    let data2 = [];
    try {
      data = [
        {
          subject: currentAvatar.archetype[0],
          A: (pulses[pulses.length - 1].answers['question-0'] / 30) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[1],
          A: (pulses[pulses.length - 1].answers['question-1'] / 20) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[2],
          A: (pulses[pulses.length - 1].answers['question-2'] / 30) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[3],
          A: (pulses[pulses.length - 1].answers['question-3'] / 20) * 100,
          fullMark: 30
        }
      ];
      data2 = [
        {
          subject: currentAvatar.archetype[4],
          A: (pulses[pulses.length - 1].answers['question-4'] / 30) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[5],
          A: (pulses[pulses.length - 1].answers['question-5'] / 20) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[6],
          A: (pulses[pulses.length - 1].answers['question-6'] / 30) * 100,
          fullMark: 30
        },
        {
          subject: currentAvatar.archetype[7],
          A: (pulses[pulses.length - 1].answers['question-7'] / 20) * 100,
          fullMark: 30
        }
      ];
    } catch {
      data = [];
      data2 = [];
    }
    return (
      <>
        <Fab
          onClick={() => window.scrollTo(0, 0)}
          color="primary"
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 999
          }}
        >
          <ArrowUpward />
        </Fab>
        <Card className="mt-3">
          <Card.Header>Dados do Usuário</Card.Header>
          <Card.Body>
            <UserForm
              currentAvatar={currentAvatar}
              key={userProfileData && userProfileData.name}
              userProfileData={userProfileData}
              courses={courses}
              turnOnLoading={turnOnLoading}
              turnOffLoading={turnOffLoading}
              setCurrentUser={setCurrentUser}
              currentUser={currentUser}
              areasList={areasList}
            />
          </Card.Body>
        </Card>

        <CardDeck ref={scrollTo} className="mt-3 mb-3">
          <Card>
            <Card.Header>Linha do tempo da Felicidade</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <LineChart
                    width={500}
                    height={300}
                    data={pulses}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5
                    }}
                  >
                    <CartesianGrid strokeDasharray="6 6" />
                    <XAxis dataKey="name" />
                    <YAxis domain={[0, 100]} />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      name="Taxa de Felicidade"
                      dataKey="happiness"
                      stroke="#82ca9d"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header>Radar da Felicidade atual</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <RadarChart
                    outerRadius={130}
                    width={300}
                    height={300}
                    data={data}
                  >
                    <PolarGrid domain={[0, 100]} />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    <Radar
                      name=""
                      dataKey="A"
                      stroke="#82ca9d"
                      fill="#82ca9d"
                      fillOpacity={0.6}
                    />
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </CardDeck>
        <CardDeck className="mt-3 mb-3">
          <Card>
            <Card.Header>Linha do tempo de {currentAvatar.pulse}</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <LineChart
                    width={500}
                    height={300}
                    data={pulses}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5
                    }}
                  >
                    <CartesianGrid strokeDasharray="6 6" />
                    <XAxis dataKey="name" />
                    <YAxis domain={[0, 100]} />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="archetype"
                      name={`Taxa de ${currentAvatar.pulse}`}
                      stroke="#8884d8"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>Radar de {currentAvatar.pulse} atual</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <RadarChart
                    outerRadius={130}
                    width={300}
                    height={300}
                    data={data2}
                  >
                    <PolarGrid domain={[0, 100]} />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    <Radar
                      name=""
                      dataKey="A"
                      stroke="#8884d8"
                      fill="#8884d8"
                      fillOpacity={0.6}
                    />
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </CardDeck>
        {/* <Card className="mt-3">
          <Card.Header>Experiência Profissional</Card.Header>
          <Card.Body>
            <ProfessionalXPForm
              key={userProfileData && userProfileData.name}
              userProfileData={userProfileData}
              courses={courses}
              turnOnLoading={turnOnLoading}
              turnOffLoading={turnOffLoading}
              setCurrentUser={setCurrentUser}
              currentUser={currentUser}
            />
          </Card.Body>
        </Card>
        <Card className="mt-3">
          <Card.Header>Idiomas</Card.Header>
          <Card.Body>
            <LanguageForm
              key={userProfileData && userProfileData.name}
              userProfileData={userProfileData}
              courses={courses}
              turnOnLoading={turnOnLoading}
              turnOffLoading={turnOffLoading}
              setCurrentUser={setCurrentUser}
              currentUser={currentUser}
            />
          </Card.Body>
        </Card> */}
      </>
    );
  }
}

export default UserDashboard;
